import React, { useState } from "react";
import strings from "../../constants/strings";
import { Form, Button, Row } from "react-bootstrap";
import { validatePassword } from "../../helper";
import { FaKey } from "react-icons/fa";

export default function NewPassword(props) {
  const {
    isMobile,
    showAlert,
    setNewPassword,
    handleFormChange,
    setIsForgotPassword,
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);

  const handleForgotPasswordSubmit = async () => {
    if (
      password &&
      validatePassword(password) &&
      password === confirmPassword
    ) {
      setIsForgotPassword(true);
      setNewPassword(password);
      handleFormChange("otp");
      showAlert(
        "Forgot Password",
        "Please enter the otp received on your registered mobile number",
        true
      );
    } else if (!validatePassword(password)) {
      showAlert("Forgot Password", "Password is invalid");
    } else if (!password) {
      showAlert("Forgot Password", "Password cannot be empty");
    } else if (password !== confirmPassword) {
      showAlert(
        "Forgot Password",
        "Password and confirm password are not equal"
      );
    }
  };

  return (
    <div className="landing-form">
      <Form
        onSubmit={async (event) => {
          event.preventDefault();
          handleForgotPasswordSubmit();
        }}
      >
        <Row className="d-block">
          <Form.Group>
            <Form.Label className="landing-label">
              {strings.PASSWORD}
            </Form.Label>
            <div className="d-flex">
              <FaKey
                size="15"
                color="#ac8d30"
                className={isMobile ? "password-key-mobile" : "password-key"}
                onClick={() => setShowPassword(!showPassword)}
              />
              <Form.Control
                className="landing-input"
                type={showPassword ? "text" : strings.PASSWORD}
                placeholder="Enter Password"
                value={password || ""}
                onChange={(event) =>
                  setPassword(
                    event.target.value === "" ? null : event.target.value
                  )
                }
              />
            </div>
          </Form.Group>
        </Row>
        <Row className="d-block">
          <Form.Group>
            <Form.Label className="landing-label">
              {strings.CONFIRM_PASSWORD}
            </Form.Label>
            <div className="d-flex">
              <FaKey
                size="15"
                color="#ac8d30"
                className={isMobile ? "password-key-mobile" : "password-key"}
                onClick={() => setShowPassword(!showPassword)}
              />
              <Form.Control
                className="landing-input"
                type={showPassword ? "text" : strings.PASSWORD}
                placeholder="Enter Confirm Password"
                value={confirmPassword || ""}
                onChange={(event) =>
                  setConfirmPassword(
                    event.target.value === "" ? null : event.target.value
                  )
                }
              />
            </div>
          </Form.Group>
        </Row>
        <Row className="mt-4">
          <Form.Group className="d-flex justify-content-center w-100">
            <Button
              variant="outline-warning"
              className="landing-button w-50"
              type="submit"
            >
              NEXT
            </Button>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
}
